







import { Vue, Component, Prop } from 'vue-property-decorator';
import { Option, SparkVisionSetting, Select } from '@/models/Configurator';
import { HtmlImageContainer } from '@/models/Image';
@Component
export default class ConfigView extends Vue {
    @Prop() configSelects!: Array<Select>;
    @Prop() sparkVisionSetting!: SparkVisionSetting;
    @Prop() dummyImage!: string;
    private imageLoaded: boolean = true;
    //private studioPath: string = 'https://ds.spark-vision.com/BallingslovStudio/'; // 'https://ds.spark-vision.com/BallingslovStudio_WIP/'
    private studioPath: string = 'https://ds.spark-vision.com/BallingslovStudio_WIP/'
    private stuidoParams: any = {
        strict: false,
        shadows: false,
        background: false,
        enc_type: 'simple',
        encoded_config: 'BallingslovStudio_Set01;'
    };

    private cropping: string =
        '&cropped_width=' +
        this.sparkVisionSetting.croppedWidth +
        '&cropped_height=' +
        this.sparkVisionSetting.croppedHeight +
        '&crop_y_ratio=' +
        this.sparkVisionSetting.croppedYRatio +
        '&crop_x_ratio=' +
        this.sparkVisionSetting.croppedXRatio;
    constructor() {
        super();
    }

    get imageBaseUrl(): string {
        const qs = Object.keys(this.stuidoParams)
            .map((key: any) => `${key}=${this.stuidoParams[key]}`)
            .join('&');
        return this.studioPath + 'get_image_from_encoded_string?' + qs;
    }

    get configImageSrc(): string {
        this.imageLoaded = true;
        if (typeof this.configSelects !== 'undefined') {
            let text = '';
            for (const select of this.configSelects) {
                if (select.showInSparkVision) {
                    if (select.selectedOption.length) {
                        text += select.selectedOption[0].navisionId + ',';
                    } else if (select.hiddenId) {
                        text += select.hiddenId + ',';
                    }
                }
            }
            return this.imageBaseUrl + text + this.cropping;
        }
        return this.imageBaseUrl + 'No options selected';
    }
}
